import parseInt from 'lodash/parseInt';
export const _parseInt = parseInt;
